import { render } from "./CompleteAdmin.vue?vue&type=template&id=6f0a935e&scoped=true"
import script from "./CompleteAdmin.vue?vue&type=script&lang=js"
export * from "./CompleteAdmin.vue?vue&type=script&lang=js"

import "./CompleteAdmin.vue?vue&type=style&index=0&id=6f0a935e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0a935e"]])

export default __exports__